import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

/* ===================== PACKAGES APIs ===================== */

// CREATE Package
export const createPackage = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/packages`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET all Packages
export const getPackages = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/packages`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET single Package
export const getPackageById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/packages/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// UPDATE Package
export const updatePackage = (id: number | string, payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/packages/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};


/* ===================== PACKAGE SERVICES APIs ===================== */

// CREATE Package Service
export const createPackageService = (payload: any) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/package-services`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET all Package Services
export const getPackageServices = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/package-services`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET single Package Service
export const getPackageServiceById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/package-services/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// UPDATE Package Service
export const updatePackageService = (
  id: number | string,
  payload: any
) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/package-services/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};